const core = {
  coral: '#FF595A',
  darkBlue: '#070243',
  disabledDarkBlue: '#FDA1A2',
  lightBlue: '#4851F6',
  callToAction: '#4435E6',
  disabledCallToAction: '#a29af5',
  black: '#000000',
  gray: '#828282',
};

const colors = {
  core,
  white: '#FFFFFF',
  black: '#000000',
  gray1: '#333333',
  gray2: '#4F4F4F',
  gray3: '#828282',
  gray4: '#BDBDBD',
  gray5: '#E0E0E0',
  gray6: '#F2F2F2',
  gray7: '#F6F6F6',
  gray8: '#F2F2F2',
  gray9: '#EEEEEE',
  gray10: '#E0E0E052',
  gray11: '#919191',
  grayBlue1: '#c3c2d1', // used with blue icons in the background,
  grayBlue2: '#F7F9FC', // used with blue icons in the background,
  grayBlue3: '#0702430A', // used in column background,
  lightGreen: '#BAE2A726',
  errorRedPrimary: '#ff0000',
  darkCoral: '#FDA1A2', // used when primary button is disabled & active.
  purpleGray: '#ADABBD', // used when secondary button is active
  hoverOnDropdownEl: '#e0e0e066',
  modalBackdrop: '#00000085',
  announcement: {
    info: core.lightBlue,
    warning: '#FFA500',
  },
  fileError: '#EB3323',
};

export default colors;
